/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-12 14:35:17
 * @FilePath: \senlan-ai-ui\src\pages\components\ResponseBubble\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useMemo } from 'react'
import { useStyle } from './style'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import { getMarkdownRenderConfig } from './utils'
import MessageFooter from './components/CopyButton'
import ThinkLoading from '../../components/ThinkLoading'
import type { CollapseProps } from 'antd'
import { Collapse } from 'antd'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import './style.css'
import deepSeek from '@/assets/icon/deepthink.png'
interface ResponseBubbleProps {
  content: string
  onlineSearchResults?: any[]
  thinkContent?: string
  isError?: boolean
  isFinished?: boolean
  footer?: () => React.ReactNode
  onReload?: () => void
}

const ResponseBubble: React.FC<ResponseBubbleProps> = ({
  thinkContent,
  content,
  onlineSearchResults,
  isError,
  isFinished,
  footer = null,
  onReload,
}) => {
  const { styles } = useStyle()

  const markdownRenderConfig = useMemo(
    () => getMarkdownRenderConfig(styles),
    [styles]
  )

  //  在组件中计算当前状态
  const getStatus = () => {
    if (content) return 'done'
    if (thinkContent) return 'thinking'
    if (onlineSearchResults) return 'searching'
    return 'done'
  }

  const currentStatus = getStatus()

  const processed = (text: string) => {
    return text?.replace(/<\^(\d+)>/g, (_, id) => '')
    // `<Ref id="${id}" />`
  }
  const parsedOnline = () => {
    if (!onlineSearchResults) return []
    else if (content && typeof onlineSearchResults === 'string')
      return JSON.parse(onlineSearchResults.replace(/<\/?search>/g, ''))
    else return onlineSearchResults
  }
  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: (
        <div className={styles.thinkHeader}>
          <img src={deepSeek} alt="深度思考" style={{ width: '18px' }} />{' '}
          <div style={{ marginLeft: '10px' }}>深度思考</div>
        </div>
      ),
      children: (
        <div className={styles.thinkContent}>
          {processed(thinkContent?.trim().replace(/[*#]/g, ''))}
        </div>
      ),
    },
  ]

  return (
    <div className={styles.botMessage} key={'responseBubble'}>
      {currentStatus != 'done' && (
        <ThinkLoading currentStatus={currentStatus} />
      )}

      {!isError ? (
        <div className={`${styles.messageText} `}>
          {thinkContent && (
            <Collapse
              defaultActiveKey={['1']}
              ghost
              items={items}
              className={styles.thinkContainer}
              expandIconPosition="end"
            />
          )}
          <ReactMarkdown
            remarkPlugins={[remarkGfm, remarkMath]}
            rehypePlugins={[rehypeRaw, rehypeKatex]}
            components={markdownRenderConfig as any}
          >
            {processed(content)}
          </ReactMarkdown>

          {isFinished &&
            (footer?.() ?? (
              <MessageFooter
                value={content}
                onReload={onReload}
                onlineSearchResults={parsedOnline()}
              />
            ))}
        </div>
      ) : (
        <div style={{ color: 'red' }}>{content}</div>
      )}
    </div>
  )
}

export default ResponseBubble
